/* eslint-disable jsx-a11y/no-onchange */
import { OnBoardingSelectProps } from '@/types/props/components/onboarding';
import clsx from 'clsx';
import SpiritoryLabel from './SpiritoryLabel';
import { MdClose } from 'react-icons/md';
import DefaultButton from '@/components/common/default/DefaultButton';

export default function SpiritorySelect({
  value,
  onChange,
  name,
  options,
  defaultOptionText,
  label,
  required,
  canDelete,
  ...props
}: OnBoardingSelectProps) {
  if (label) {
    return (
      <div className="tw-flex tw-flex-col tw-gap-3 tw-w-full">
        <SpiritoryLabel htmlFor={name} required={required}>
          {label}
        </SpiritoryLabel>
        <div className="tw-relative">
          <select
            {...props}
            id={name}
            name={name}
            className={clsx(
              'tw-w-full tw-py-2.5 tw-border tw-border-solid tw-border-platinum-gray tw-bg-white disabled:tw-cursor-not-allowed disabled:tw-opacity-50 tw-outline-none focus:tw-border-2 focus:tw-ring-2 tw-font-medium tw-font-plusJakartaSans tw-leading-[22.68px] tw-text-[#232323]',
              'focus:tw-border-main-shades-500 focus:tw-ring-main-shades-500',
              'tw-px-4 tw-rounded-xl'
            )}
            value={value}
            onChange={onChange}
          >
            <option value="" disabled>
              {defaultOptionText}
            </option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {canDelete && (
            <DefaultButton
              className="tw-absolute tw-top-1/2 tw-right-4 tw-transform tw--translate-y-1/2 tw-cursor-pointer tw-text-slate-gray"
              aria-label="Clear"
            >
              <MdClose
                onClick={() => {
                  const event = new Event('change', { bubbles: true });
                  const input = document.getElementById(
                    name
                  ) as HTMLSelectElement;
                  input.value = '';
                  input.dispatchEvent(event);
                }}
              />
            </DefaultButton>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="tw-relative">
      <select
        {...props}
        id={name}
        name={name}
        className={clsx(
          'tw-w-full tw-py-2.5 tw-border tw-border-solid tw-border-platinum-gray tw-bg-white disabled:tw-cursor-not-allowed disabled:tw-opacity-50 tw-outline-none focus:tw-border-2 focus:tw-ring-2 tw-font-medium tw-font-plusJakartaSans tw-leading-[22.68px] tw-text-[#232323]',
          'focus:tw-border-main-shades-500 focus:tw-ring-main-shades-500',
          'tw-px-4 tw-rounded-xl'
        )}
        value={value}
        onChange={onChange}
      >
        <option value="" disabled>
          {defaultOptionText}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {canDelete && (
        <DefaultButton
          className="tw-absolute tw-top-1/2 tw-right-4 tw-transform tw--translate-y-1/2 tw-cursor-pointer tw-text-slate-gray"
          aria-label="Clear"
        >
          <MdClose
            onClick={() => {
              const event = new Event('change', { bubbles: true });
              const input = document.getElementById(name) as HTMLSelectElement;
              input.value = '';
              input.dispatchEvent(event);
            }}
          />
        </DefaultButton>
      )}
    </div>
  );
}
